<app-header></app-header>
<div class="donate">
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-sm-8 text-center">
        <form ngNoForm action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
          <input type="hidden" name="cmd" value="_s-xclick">
          <input type="hidden" name="hosted_button_id" value="K7GH2AZQQVDSW">
          <input type="hidden" name="on0" value="Buy Coffee for our team">
          <h1>Buy Coffee for our team</h1>
          <p>MyResumeFormat is a free IA assisted professional resume builder.</p>
          <p>We strongly feel that students and job seekers shouldn't pay to create a beautiful resume! However, in order to achieve this, we need your support to maintain the server &amp; development cost which comes in hundreds of dollars a month. Your contribution, big or small matters.</p>
          <div class="row justify-content-md-center">
            <div class="col-md-5">
              <select name="os0">
                <option value="1 coffee">1 coffee $1.00 USD</option>
                <option value="5 coffee">5 coffee $5.00 USD</option>
                <option value="20 coffee">20 coffee $20.00 USD</option>
                <option value="50 coffee">50 coffee $50.00 USD</option>
                <option value="100 coffee">100 coffee $100.00 USD</option>
              </select>
              <div class="donate__button">
                <input type="hidden" name="currency_code" value="USD">
                <input type="image" src="https://www.paypalobjects.com/en_GB/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal – The safer, easier way to pay online!">
                <img alt="" border="0" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
